module.exports = __webpack_public_path__ + "static/media/YF11_7.85764fc2.jpg";